// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__20atg","selected":"Chip_selected__2CCr_"};